<script>
import { required } from "vuelidate/lib/validators";
import DatePicker from "vue2-datepicker";
import moment from "moment";
import Multiselect from "vue-multiselect";

// Custom Components
import DataUpdateInfo from "@/components/dataUpdateInfo.vue";
import PbxService from "@/helpers/APIService/pbx.service";
import Middleware from "@/helpers/middlewares";
import errorHandler from "@/helpers/errorHandler";
import pbxService from "@/helpers/APIService/pbx.service";

export default {
  data() {
    return {
      formState: {
        extension: "",
        alarm_time: "",
        wakeup_time: "",
        source: "UI",
        retry: "0",
        domain_name: "",
      },
      extensions: [],
      submitted: false,
      isBtnLoading: false,
      domainOptions: [],
      dataToBeUpdate: {},
    };
  },
  components: {
    DataUpdateInfo,
    DatePicker,
    Multiselect,
  },
  props: {
    WakeUpForm: Object,
    isEdit: Boolean,
  },
  emits: ["submitted", "cancelSubmit"],
  validations: {
    formState: {
      domain_name: { required },
      alarm_time: { required },
      extension: { required },
    },
  },
  mounted() {
    this.setValue();
  },
  methods: {
    // Method is used to get Domain list
    async setValue() {
      PbxService.getDomainList()
        .then((response) => {
          if (response.status == false) {
            return Middleware.notification(response.message, "warning");
          }
          if (response.length !== 0) {
            response.forEach((element) => {
              // if (this.isEdit) {
              //   this.formState.domain_name = {
              //     value: element.domain_uuid,
              //     text: element.domain_name,
              //     item: element,
              //   };

              //   this.formState.wakeup_time = moment(element.wakeup_time).format(
              //     "DD MM YYYY hh:mm:ss"
              //   );
              // }
              this.domainOptions.push({
                value: element.domain_uuid,
                text: element.domain_name,
                item: element,
              });
            });
          }
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    // User Form Submit
    onSubmit() {
      this.isloading = true;
      this.submitted = true;
      this.isBtnLoading = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.isBtnLoading = false;
        return;
      } else {
        PbxService.addWakeUpCall(this.formState.domain_name.value, {
          alarm_time: this.formState.alarm_time,
          wakeup_time: this.formState.alarm_time,
          extension: this.formState.extension.value,
          source: "UI",
          retry: "0",
        })
          .then((res) => {
            this.isBtnLoading = false;
            Middleware.notification(
              "Wakeup call created successfully !!",
              "success"
            );
            this.$emit("submitted", this.WakeUpForm);
          })
          .catch((error) => {
            this.isBtnLoading = false;
            errorHandler(error);
          });
      }
    },
    changeOpt(data) {
      this.extensions = [];
      pbxService
        .getExtensionListByColurm(
          "?column=e.extension_uuid&column=e.extension",
          data.value
        )
        .then((response) => {
          if (response.status == false) {
            return Middleware.notification(response.message, "error");
          }
          response.map((element, index) => {
            if (this.isEdit) {
              this.formState.extension = {
                value: element.extension,
                text: element.extension,
              };
            }
            this.extensions.push({
              ...response[index],
              text: response[index].extension,
              value: response[index].extension,
            });
          });
        })
        .catch((error) => {
          this.is_loading_data = false;
          errorHandler(error);
        });
    },
    // Method is use for cancel to add new building
    cancelSubmit() {
      this.$emit("cancelSubmit");
    },
  },
};
</script>

<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <h4>{{ isEdit ? "Update" : "Add New" }} Wakeup call</h4>
        <hr />
      </div>
      <b-form @submit.prevent="onSubmit">
        <div class="row">
          <div class="col-md-4 col-sm-6">
            <b-form-group class="mb-3" label-for="select-domain">
              <span slot="label">
                <span>Select Domain</span>
                <span class="text-danger">*</span>
              </span>
              <Multiselect
                v-model="formState.domain_name"
                :options="domainOptions"
                @input="changeOpt(formState.domain_name)"
                :show-labels="false"
                placeholder="Select Domain"
                label="text"
                track-by="value"
                id="select-domain"
                :class="{
                  'is-invalid': submitted && $v.formState.extension.$error,
                }"
              ></Multiselect>
              <div
                v-if="submitted && $v.formState.extension.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.formState.extension.required">
                  Domain Name is required.
                </span>
              </div>
            </b-form-group>
          </div>
          <div class="col-md-4 col-sm-6">
            <b-form-group class="mb-3" label-for="select-domain">
              <span slot="label">
                extension Number
                <span class="text-danger">*</span>
              </span>
              <div class="row mx-1 align-items-end">
                <Multiselect
                  v-model="formState.extension"
                  :options="extensions"
                  :show-labels="false"
                  placeholder="Select Domain"
                  label="text"
                  track-by="value"
                  id="select-domain"
                  :class="{
                    'is-invalid': submitted && $v.formState.extension.$error,
                  }"
                ></Multiselect>
                <div
                  v-if="submitted && $v.formState.extension.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.formState.extension.required">
                    extension Number is required.
                  </span>
                </div>
              </div>
            </b-form-group>
          </div>
          <div class="col-md-4 col-sm-6">
            <b-form-group class="mb-3" label-for="extension_limit">
              <span slot="label">
                Alarm Time <span class="text-danger">*</span>
              </span>
              <date-picker
                v-model="formState.alarm_time"
                type="datetime"
                id="extension_limit"
                placeholder="Select date and time"
                :clearable="false"
                value-type="format"
                :class="{
                  'is-invalid': submitted && $v.formState.alarm_time.$error,
                }"
              ></date-picker>
              <div v-if="submitted" class="invalid-feedback">
                <span v-if="!$v.formState.alarm_time.required">
                  Alarm Time is required.
                </span>
              </div>
            </b-form-group>
          </div>

          <hr />
          <div class="col-md-12">
            <b-button
              class="float-end ms-2 mb-3"
              variant="outline-primary"
              type="reset"
              @click="cancelSubmit"
            >
              Cancel
            </b-button>
            <b-button
              class="float-end mb-3"
              variant="outline-primary"
              type="submit"
              :class="{
                disabled: isBtnLoading,
              }"
            >
              <i
                class="bx bx-loader bx-spin font-size-16 align-middle me-2"
                v-if="isBtnLoading"
              ></i>
              {{ isEdit ? "Update" : "Save" }}
            </b-button>
          </div>
          <DataUpdateInfo :data-to-be-show="dataToBeUpdate" />
        </div>
      </b-form>
    </div>
  </div>
</template>
